import TextField from '@mui/material/TextField';
import ComponentTable from '../../../Components/Table/Index';
import {
  ParagraphValores,
  ParagraphTextoValores,
  ContainerValores,
} from './ContasReceberPesquisarStyle';
import * as Icon from '@mui/icons-material/';
import { Form, Formik, Field } from 'formik';
import { MenuItem, Box, Container, IconButton } from '@mui/material';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { Button } from '../../../../shared/components/button/Button';
import useContasReceberPesquisar from '../../../../hooks/useContasReceberPesquisar';
import { Loader } from '../../../../shared/components/Loader';
import { InputMoney } from '../../../../shared/components/InputMoney';
import { formatCurrency } from '../../../../shared/utils/helpers/numbers';
import  ModalEditarParcela  from '../Modal/ModalEditarParcela';
import LoadingButton from '@mui/lab/LoadingButton';

export default function ContasReceber() {
  const {
    handleNavigation,
    handleChangeDropdownStatus,
    handleChangeDropdownStatusBoleto,
    handlePrint,
    dropdownValueStatus,
    dropdownValueStatusBoleto,
    statisticValues,
    tableRows,
    tableColumns,
    handleSubmit,
    loading,
    initialValues,
    STATUS,
    STATUS_BOLETO,
    modalEditarParcelaOpen,
    handleCloseEditarParcelaModal,
    selectedParcela,
    formRef,
    downloadRelatorio,
    loadingRelatorio,
    // recibo de locação
    handleChangeDropdownFinalidade,
    dropdownValueFinalidade,
    OPTIONS_FINALITY,
    gerarRecibosLote,
    loadingRecibos,
    podeGerarRecibos,
    qtdRecibosNaTela,
    qtdZeradasNaTela
  } = useContasReceberPesquisar();

  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 1 },
      }}
    >
      <div className={'pb-2'}>
        <HeaderComponent
          className={'mb-6'}
          text={'Contas a Receber'}
          ButtonRight={
            <>
              <Button
                className={''}
                variant='success'
                onClick={handleNavigation}
                iconStart={<Icon.Add />}
                title={'Incluir'}
              />
              <LoadingButton
                loading={loadingRelatorio}
                loadingPosition="start"
                startIcon={<Icon.FileDownload />}
                variant="outlined"
                onClick={downloadRelatorio}
                  sx={{
                  color: '#fff',
                  backgroundColor: '#1976d2',
                  '&:hover': { backgroundColor: '#1769bb' },
                  textTransform: 'none',
                  marginLeft: '16px',
                  fontSize: '16px',
                  '&&.Mui-disabled': {
                    color: '#ddd',
                  },
                }}
              >
                <p>Relatório</p>
              </LoadingButton>
              {/* [NOVO 12/08] Gera os recibos das parcelas de locação que a busca
                  trouxe. Fica DESABILITADO com o motivo no title, em vez de escondido:
                  botão que só aparece em certa combinação de filtros faz o usuário
                  achar que a função não existe. */}
              <LoadingButton
                loading={loadingRecibos}
                loadingPosition="start"
                startIcon={<Icon.ReceiptLong />}
                variant="outlined"
                disabled={!podeGerarRecibos}
                onClick={gerarRecibosLote}
                title={
                  podeGerarRecibos
                    ? `Gerar recibos das ${qtdRecibosNaTela} parcela(s) de locação listadas`
                      + (qtdZeradasNaTela > 0
                          ? ` (${qtdZeradasNaTela} com valor R$ 0,00 não geram recibo)`
                          : '')
                    : 'Filtre a Finalidade em "Locação" e pesquise para habilitar'
                }
                sx={{
                  color: '#fff',
                  backgroundColor: '#2e7d32',
                  '&:hover': { backgroundColor: '#276b2a' },
                  textTransform: 'none',
                  marginLeft: '16px',
                  fontSize: '16px',
                  '&&.Mui-disabled': {
                    color: '#ddd',
                    backgroundColor: '#9e9e9e',
                  },
                }}
              >
                <p>Gerar Recibos</p>
              </LoadingButton>
            </>
          }
        />
        <Box mb={2} />

        <Formik initialValues={initialValues} onSubmit={handleSubmit} innerRef={formRef}>
          {({ handleChange, setFieldValue, values, submitForm }) => (
            <Form className={'grid grid-cols-12'}>
              <Container
                className={'col-span-12'}
                style={{
                  paddingBottom: '20px',
                  borderRadius: '5px',
                  display: 'flex',
                }}
              >
                <ContainerValores>
                  <ParagraphValores>
                    {formatCurrency(statisticValues.TotalReceber, 2)}
                  </ParagraphValores>
                  <ParagraphTextoValores>Valor a Receber</ParagraphTextoValores>
                </ContainerValores>
                <div style={{ width: '5%' }}></div>
                <ContainerValores>
                  <ParagraphValores>
                    {formatCurrency(statisticValues.TotalPago, 2)}
                  </ParagraphValores>
                  <ParagraphTextoValores>Valor Pago</ParagraphTextoValores>
                </ContainerValores>
                <div style={{ width: '5%' }}></div>
                <ContainerValores>
                  <ParagraphValores>
                    R$
                  </ParagraphValores>
                  <ParagraphTextoValores>
                    Valor Renegociado
                  </ParagraphTextoValores>
                </ContainerValores>
              </Container>

              <TextField
                className={'col-span-2'}
                name='Status'
                id='select-status'
                select
                label='Status'
                value={dropdownValueStatus}
                onChange={handleChangeDropdownStatus}
              >
                {STATUS.map((item: any) => {
                  return (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  );
                })}
              </TextField>
              <TextField
                className={'col-span-2'}
                name='statusBoleto'
                id='select-status'
                select
                label='Status Boleto'
                value={dropdownValueStatusBoleto}
                onChange={handleChangeDropdownStatusBoleto}
              >
                {STATUS_BOLETO.map((item: any) => {
                  return (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  );
                })}
              </TextField>
              {/* [NOVO 12/08] Finalidade do pedido. É o filtro que habilita o botão de
                  gerar recibos - o recibo só existe para Locação. */}
              <TextField
                className={'col-span-2'}
                name='finalidade'
                id='select-finalidade'
                select
                label='Finalidade'
                value={dropdownValueFinalidade}
                onChange={handleChangeDropdownFinalidade}
              >
                {OPTIONS_FINALITY.map((item: any) => {
                  return (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  );
                })}
              </TextField>
              <Field
                className={'col-span-2'}
                name='vnd_id'
                as={TextField}
                label='Pedido'
                type='number'
              />
              <Field
                className={'col-span-2'}
                name='numerotitulocobranca'
                as={TextField}
                label='Nº Boleto'
                type='number'
              />
              <Field
                className={'col-span-2'}
                name='vencimento'
                as={TextField}
                label='Vencimento Inicial'
                InputLabelProps={{ shrink: true }}
                type='date'
              />
              <Field
                className={'col-span-2'}
                name='vencimentoFinal'
                as={TextField}
                label='Vencimento Final'
                InputLabelProps={{ shrink: true }}
                type='date'
              />
              <Field
                className={'col-span-2'}
                name='cliente_nome'
                as={TextField}
                label='Cliente'
                type='text'
              />
              <Field
                className={'col-span-2'}
                name='observacao'
                as={TextField}
                label='Parcela'
                type='text'
              />
              <InputMoney
                size={'medium'}
                className={'col-span-2 !pr-4'}
                name='valor'
                label='Valor Pre'
                fullWidth
                handleChange={handleChange}
                value={''}
              />
              <InputMoney
                size={'medium'}
                className={'col-span-2 !pr-4'}
                name='valor_pago'
                label='Valor Pg.'
                fullWidth
                handleChange={handleChange}
                value={''}
              />
              <InputMoney
                size={'medium'}
                className={'col-span-2 !pr-4'}
                name='Saldo'
                label='Saldo'
                fullWidth
                handleChange={handleChange}
                value={''}
              />
              <Field
                className={'col-span-3'}
                name='Descricao'
                as={TextField}
                label='Descrição'
                type='text'
              />
              <Box className={'pt-3 '}>
                <IconButton size={'large'} type={'submit'}>
                  <Icon.Search style={{ fontSize: '28px' }} />
                </IconButton>
              </Box>

              <ModalEditarParcela
                open={modalEditarParcelaOpen}
                onClose={handleCloseEditarParcelaModal}
                values={{ selectedItem: selectedParcela }}
                onSuccess={submitForm}
              />

            </Form>
          )}
        </Formik>
      </div>
      <Loader loading={loading}>
        <ComponentTable
          columns={tableColumns}
          rows={tableRows}
          tableHeight={'50vh'}
        />
      </Loader>
    </Box>
  );
}